import { AlignCenterIcon } from 'foundations-assets/icons/components/AlignCenterIcon';
import { AlignJustifyIcon } from 'foundations-assets/icons/components/AlignJustifyIcon';
import { AlignLeftIcon } from 'foundations-assets/icons/components/AlignLeftIcon';
import { AlignRightIcon } from 'foundations-assets/icons/components/AlignRightIcon';
export const Alignments = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  NONE: 'none',
  JUSTIFY: 'justify'
};
export const VerticalAlignments = {
  BOTTOM: 'baseline',
  MIDDLE: 'middle',
  TOP: 'top'
};
export const AlignmentsFormat = {
  [Alignments.LEFT]: 'alignleft',
  [Alignments.CENTER]: 'aligncenter',
  [Alignments.RIGHT]: 'alignright',
  [Alignments.JUSTIFY]: 'alignjustify',
  [Alignments.NONE]: ''
};
export const AlignmentIconNameMap = {
  left: 'imageAlignmentLeft',
  center: 'imageAlignmentMiddle',
  right: 'imageAlignmentRight',
  none: 'inline',
  baseline: 'blockAlignmentBottom',
  middle: 'blockAlignmentCenter',
  top: 'blockAlignmentTop'
};
export const AlignmentIconMap = {
  [Alignments.LEFT]: AlignLeftIcon,
  [Alignments.CENTER]: AlignCenterIcon,
  [Alignments.RIGHT]: AlignRightIcon,
  [Alignments.JUSTIFY]: AlignJustifyIcon
};